import { render } from "./AssistantMessage.vue?vue&type=template&id=422e4357&scoped=true"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"

import "./AssistantMessage.vue?vue&type=style&index=0&id=422e4357&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422e4357"]])

export default __exports__